
import {initWebComponent} from "@/helpers/web-component-helper";

export class LayerInfoMutationComponent extends HTMLElement {
    constructor(){
        super();

        let showClass = ''
        if(window.settings.ShowAllMutations === 2) {
            showClass = 'd-none'
        }

        const template = document.createElement('template');
        template.innerHTML = `
<div class="card m-3 bg-lighter" style="border-radius: 10px;min-height: 335px;">
     <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
         <h2>
             <span class="fa fa-edit title-icon"></span> Muteren
             <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnCloseInfoMenu" data-parent-element="layer-info-mutation">
                <span class="fa fa-times"></span>
             </button>
             <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu d-none">
                <span class="fa fa-minus"></span>
             </button>
         </h2>
     </div>
        <div class="card-body pl-2 divMutationHelpText ${showClass}" style="margin-top:20px">
                <p>
                    Klik op <i class="fa fa-edit"></i> bij de catalogus om te muteren
                </p>
            </div>
       <layer-info-tools-mutation></layer-info-tools-mutation>
</div> 
`;


        initWebComponent(this, template)
    }
}
